import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import './styles/Map.css'
import App from './App'
import { BrowserRouter } from 'react-router-dom'
import { AppWrapper } from './hoc/AppWrapper'
import { Provider } from 'react-redux'
import { store } from './store/store'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <AppWrapper>
        <App />
      </AppWrapper>
    </BrowserRouter>
  </Provider>,
)
